<template>
  <hr class="separator" :style="{ borderColor: item.color || '#e5e7eb' }" />
</template>

<script setup>
defineProps({
  item: Object
})
</script>

<style scoped>
.separator {
  border: none;
  border-top: 1px solid;
  margin: 6px 0;
}
</style>
